import React from 'react'

import AppConsent from 'components/Consents/AppConsents/AppConsent'
import Button, { AppButtonTypes } from 'components/Buttons/ButtonBase/Button'
import ButtonCancelApplication from 'components/Buttons/ButtonCancelApplication/ButtonCancelApplication'
import Summary from 'components/Summary/Summary'
import { Environment } from 'enviroment/AppSettings'
import useRetentionPageLogic from './hooks/useRetentionPageLogic'
import useTextContents from 'common/hooks/useTextContents'

import './RetentionPageStyles.scss'


const RetentionPage = (): JSX.Element => {

   const retentionPageTextContents = useTextContents()
   const { isMobileDevice, hashedPhoneNumber, handleSubmitRetention, handleChangeCurrentWorkflow } = useRetentionPageLogic()

   return (
      <div className='retention-page-outer-wrapper'>
         <input type="hidden" id="ptsuser_prefs" name="ptsuser_prefs" />   {/* Dodane na potrzeby skryptu BIK CFD NIE ZMIENIAĆ*/}
         <input type="hidden" id="ptsuser_prefs2" name="ptsuser_prefs2" /> {/* Dodane na potrzeby skryptu BIK CFD NIE ZMIENIAĆ*/}
         <section className='retention-page-inner-wrapper'>
            <div className='retention-page-heading-wrapper'>
               <h1>{retentionPageTextContents('retentionPage.header')}</h1>
               <p>{retentionPageTextContents('retentionPage.mainContent.part1')}</p>
               <p>{retentionPageTextContents('retentionPage.mainContent.part2')}</p>
            </div>
            <div className='retention-page-hashed-phone-number'>
               <p>{ hashedPhoneNumber }</p>
            </div>
            <AppConsent />
            <Button
               uiButtonType={AppButtonTypes.PRIMARY}
               id={Environment.formSubmitionButtonId} // Klasa używana w AppConsents do obsługi automatycznego scrolla po kliknięciu "zaznacz wszystkie zgody"
               onClick={handleSubmitRetention}
               className='retention-page-submit-button page-main-button-submission-button'
               buttonContent={
                  <span className='retention-page-submit-button-inner-content-wrapper'>
                     <p>{retentionPageTextContents('retentionPage.submitButtonText.part1')}</p>
                     <span>{retentionPageTextContents('retentionPage.submitButtonText.part2')}</span>
                  </span>
               } 
            />
            <p className='retention-page-back-to-form'>
               {retentionPageTextContents('retentionPage.standardVericicationText')}
               <button onClick={handleChangeCurrentWorkflow}>{retentionPageTextContents('retentionPage.standardVerificationButton')}</button> 
            </p>
            <ButtonCancelApplication className='retention-page-button-cancel-application'/>
         </section>
         {!isMobileDevice && <Summary isExtended={true} />}
      </div>
   )
}

export default RetentionPage